"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = exports.getLogger = void 0;
var anypoint_fetch_1 = __importDefault(require("@mulesoft/anypoint-fetch"));
var exchange_logging_1 = require("@mulesoft/exchange-logging");
var window_1 = require("./window");
var loggerConfig = function (logLevel) { return ({
    console: {
        enabled: !!logLevel,
        level: logLevel,
        timestamp: true,
        prettyPrint: true
    }
}); };
var userAgent = process.env.USER_AGENT || 'Exchange';
var config = {
    ignoreContextValidation: true,
    userAgent: (0, window_1.isClient)() ? null : userAgent,
    credentials: 'same-origin'
};
var getLogger = function (_a) {
    var logLevel = _a.logLevel;
    return (0, exchange_logging_1.logger)(loggerConfig(logLevel));
};
exports.getLogger = getLogger;
var fetch = function (_a) {
    var logLevel = _a.logLevel;
    return (0, anypoint_fetch_1.default)({
        config: config,
        logger: (0, exchange_logging_1.logger)(loggerConfig(logLevel))
    });
};
exports.fetch = fetch;
